import {CheckboxOption} from 'components/Form/Checkboxes';
import {t} from 'ttag';

const documentTypeLabel = () => ({
    acceptance: t`Acceptance Certificate`,
    all: t`All Document Types`,
    deliveryslip: t`Delivery Slip`,
    invoice: t`Invoice`,
    order: t`Order`,
    orderconfirmation: t`Order Confirmation`,
    orderslip: t`Order Slip`,
    paymentnotice: t`Payment Notice`,
    quote: t`Quote`,
    receipt: t`Receipt`,
    timesheet: t`Timesheet`,
});
export const documentTypeLabelByType = (type: string): string => {
    const labels: Record<string, string> = documentTypeLabel();
    const result = labels[type];
    if (!result) throw new Error(`Unknown document type: ${type}`);
    return result;
};
export const documentTypeCheckboxOptions = (): CheckboxOption[] => {
    const labels = documentTypeLabel();
    return [
        {
            label: labels.order,
            name: 'order',
        },
        {
            label: labels.quote,
            name: 'quote',
        },
        {
            label: labels.orderslip,
            name: 'orderslip',
        },
        {
            label: labels.orderconfirmation,
            name: 'orderconfirmation',
        },
        {
            label: labels.timesheet,
            name: 'timesheet',
        },
        {
            label: labels.deliveryslip,
            name: 'deliveryslip',
        },
        {
            label: labels.acceptance,
            name: 'acceptance',
        },
        {
            label: labels.paymentnotice,
            name: 'paymentnotice',
        },
        {
            label: labels.invoice,
            name: 'invoice',
        },
        {
            label: labels.receipt,
            name: 'receipt',
        },
    ];
};
